<template>
  <tr class="product">
    <td class="small-cell">{{theProduct.name}}</td>
    <td class="small-cell"><img class="p-img" :src="theProduct.image" /></td>
    <td class="small-cell">{{theProduct.slug}}</td>
    <td class="small-cell"><button @click="slugMe" class="purple-btn ml-2">افزودن نامک</button></td>
  </tr>    
</template>
<script>
export default {
    methods:{
      slugMe(){
        this.$emit('slugMe',this.theProduct.id)
      }
    },
    props:['theProduct']
}
</script>
<style scoped>
td {
  border: 1px solid rgba(127, 127, 127, 0.2);
  white-space: pre-wrap;
  padding: 0.5rem;
  word-break: break-all;
}

tr {
  width: 100%;
}

.order-locker img{
    width: 50%;
}

.small-cell{
  max-width: 10%;
}

.mid-cell{
  max-width: 12.5%;
  word-break: break-all;
}

.mid-cell p{
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  width:25vw;
}

.p-img{
  width: 80px;
}

.large-cell{
  width: 15vw;
}

</style>